import { gql } from "@apollo/client";

export const AUTORIZAR_CONEXIONES_MASIVO = gql`
    mutation autorizarConexionesMasivo($contratos: [AutorizarMasivoInput!]!) {
    autorizarConexionesMasivo(contratos: $contratos){
    success
    }
  }
`;